import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './auth/JwtContext';

/* This code is rendering the React application to the DOM. */
const root = ReactDOM.createRoot(document.getElementById('root'));
/* This code is rendering the React application to the DOM using the `ReactDOM.createRoot` method. It
is wrapping the `App` component with several providers, including `AuthProvider`, `HelmetProvider`,
and `BrowserRouter`. The `AuthProvider` provides authentication context to the application, the
`HelmetProvider` provides a way to manage the document head, and the `BrowserRouter` provides
client-side routing. The `React.StrictMode` component is used to highlight potential problems in the
application during development. */
root.render(
  <React.StrictMode>
    <AuthProvider>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
